import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";
import { getAdmins, getUserdetails } from "../../Localstorage/localstorage";
import RP_Avatar from "../RP_Avatar";
import { filterAdminsAgenda } from "../../function";
import { classNames } from "./calenderUtilties";

function phoneNumber(phoneNumber) {
  // Check if the first character is '0' and remove it
  if (phoneNumber.startsWith("0")) {
    const numberphone = phoneNumber.substring(1);
    return `32${numberphone}`; // or phoneNumber.slice(1)
  }
  return `32${phoneNumber}`; // Return as-is if no leading '0'
}

const CrudEventCalendly = ({ openModel = false, setOpenModel }) => {
  const admins = getAdmins() || [];
  const usersdetails = getUserdetails();
  const eventOptions = [
    { value: "free-health-talk", label: "Free Health Talk" },
    { value: "follow-up-in-person", label: "Follow-Up In Person (75EUR)" },
    { value: "follow-up-online", label: "Follow-Up Online (75EUR)" },
    { value: "intake-online", label: "Intake online (150EUR)" },
    { value: "intake-in-person", label: "Intake in person (150EUR)" },
    { value: "nabespreking-bloedanalyse", label: "Nabespreking bloedanalyse" },
    { value: "prikmoment", label: "Prikmoment" },
  ];
  const eventUserMapping = {
    "free-health-talk": filterAdminsAgenda(admins, ["repeat-marleen","repeat-cara"]),
    "intake-online": filterAdminsAgenda(admins, [
      "repeat-marleen",
      "repeat-natasja",
      "repeat-cara",
    ]),
    "intake-in-person": filterAdminsAgenda(admins, [
      "repeat-marleen",
      "repeat-natasja",
      "repeat-cara",
    ]),
    "follow-up-in-person": filterAdminsAgenda(admins, [
      "repeat-marleen",
      "repeat-natasja",
      "repeat-cara",
    ]),
    "follow-up-online": filterAdminsAgenda(admins, [
      "repeat-marleen",
      "repeat-natasja",
      "repeat-cara",
    ]),
    "nabespreking-bloedanalyse": filterAdminsAgenda(admins, [
      "repeat-natasja",
      "repeat-cara",
    ]),
    "prikmoment": filterAdminsAgenda(admins, [
      "repeat-natasja"
    ]),
  };

  const [selectedEvent, setSelectedEvent] = useState("free-health-talk");
  const [selectedUser, setSelectedUser] = useState(
    eventUserMapping["free-health-talk"]?.[0] || null
  );

  const [availableUsers, setAvailableUsers] = useState(
    eventUserMapping[selectedEvent] || []
  );

  useEffect(() => {
    const usersForEvent = eventUserMapping[selectedEvent] || [];
    setAvailableUsers(usersForEvent);
    setSelectedUser(usersForEvent[0] || null);
  }, [selectedEvent]);

  const handleEventChange = (e) => {
    setSelectedEvent(e.target.value);
  };

  const calendlyUrl = `https://calendly.com/${selectedUser?.calendly_info?.slug}/${selectedEvent}?primary_color=306535&hide_gdpr_banner=1`;

  return (
    <Dialog open={openModel} onClose={setOpenModel} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-full overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-0 text-center sm:px-6 sm:py-6">
          <DialogPanel
            transition
            className="relative h-[100dvh] w-full transform overflow-y-auto rounded-none border-0 bg-white text-left shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:h-auto sm:max-h-[94dvh] sm:max-w-6xl sm:rounded-2xl sm:border sm:border-slate-200 data-[closed]:sm:scale-95 dark:border-slate-700 dark:bg-slate-900"
          >
            <div className="border-b border-slate-200 bg-gradient-to-r from-emerald-700 to-emerald-600 px-4 py-4 sm:px-6 dark:border-slate-700">
              <h2 className="text-lg font-semibold text-white sm:text-xl">Nieuwe afspraak plannen</h2>
              <p className="mt-1 text-xs text-emerald-100 sm:text-sm">
                Kies een afspraaktype en selecteer daarna een specialist.
              </p>
            </div>

            <div className="space-y-4 p-4 sm:space-y-5 sm:p-6">
              <div className="space-y-4 rounded-xl border border-slate-200 bg-slate-50/70 p-4 dark:border-slate-700 dark:bg-slate-800/40">
                <div>
                  <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200">
                    Type afspraak
                  </label>
                  <select
                    className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 shadow-sm outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:focus:ring-emerald-900"
                    value={selectedEvent}
                    onChange={handleEventChange}
                  >
                    {eventOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <p className="mb-2 text-sm font-medium text-slate-700 dark:text-slate-200">
                    Specialist
                  </p>
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
                    {availableUsers.map((user, index) => (
                      <button
                        type="button"
                        onClick={() => setSelectedUser(user)}
                        key={index}
                        className={classNames(
                          "flex items-center gap-3 rounded-xl border px-3 py-2 text-left transition",
                          selectedUser?.calendly_info?.slug === user?.calendly_info?.slug
                            ? "border-emerald-500 bg-emerald-50 shadow-sm dark:bg-emerald-900/30"
                            : "border-slate-300 bg-white hover:border-emerald-300 dark:border-slate-600 dark:bg-slate-900"
                        )}
                      >
                        <RP_Avatar avatar={user?.avatar} size={12} />
                        <div>
                          <p className="text-sm font-medium text-slate-800 dark:text-slate-100">
                            {user?.first_name} {user?.last_name}
                          </p>
                          <p className="text-xs text-slate-500 dark:text-slate-400">
                            {user?.calendly_info?.slug}
                          </p>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div
                id="calendlyEmbed"
                className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-950"
                style={{ display: selectedUser && selectedEvent ? "block" : "none" }}
              >
                <InlineWidget
                  url={calendlyUrl}
                  prefill={{
                    email: usersdetails?.email,
                    firstName: usersdetails?.first_name,
                    lastName: usersdetails?.last_name,
                    name: usersdetails?.full_name,
                    smsReminderNumber: "32471634353",
                    guests: [],
                    customAnswers: {
                      a1: usersdetails?.phone_number
                        ? phoneNumber(usersdetails?.phone_number)
                        : "",
                    },
                    date: new Date(Date.now() + 86400000),
                  }}
                  styles={{ height: "min(75dvh, 700px)", width: "100%" }}
                />
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default CrudEventCalendly;
